module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-burgundy012-1200x2490.23e5c165.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-burgundy012-1200x2490.jpg
// module id = 1089
// module chunks = 37